import axios from 'axios';
import { getIgnoreMaintenanceMode, getMaintenanceModeSecretToken } from '../bridges/maintenanceBridge';
import { fetchAuthSession } from 'aws-amplify/auth';

//#region Axios Interceptors
axios.interceptors.request.use(
  async (config) => {
    // Base URL in dev
    if (import.meta.env.VITE_ENV === 'development') {
      config.baseURL = import.meta.env.VITE_FARMER_API_URL;
    }

    // Best-effort auth: NEVER throw here
    try {
      const session = await fetchAuthSession();
      const jwt = session?.tokens?.accessToken?.toString();


      if (jwt) {
        config.headers = config.headers ?? {};
        config.headers['Authorization'] = `Bearer ${jwt}`;
      }
    } catch {
      // No session yet -> proceed without Authorization header
    }

    config.headers = config.headers ?? {};
    config.headers['content-type'] = 'application/json';

    // Maintenance bypass header
    if (getIgnoreMaintenanceMode()) {
      const token = getMaintenanceModeSecretToken();
      if (token) {
        config.headers['X-Bypass-Maintenance'] = token;
      }
    } else {
      delete config.headers['X-Bypass-Maintenance'];
    }

    return config;
  },
  (error) => {
    console.error('ERROR FROM HTTPAGENT:', error);
    return Promise.reject(error);
  }
);

//#endregion

export class HttpAgent {
  static responseBody = (response) => {
    if (response) return response.data;
  };

  static cancelRequest = () => {
    const cancelToken = axios.CancelToken.source();
    cancelToken.cancel();
  };

  static get(url, header) {
    return axios
      .get(url, header)
      .catch((err) => {
        throw new Error(err?.response?.data?.message ?? err);
      })
      .then(HttpAgent.responseBody);
  }

  static post(url, body, header) {
    return axios
      .post(url, body, header)
      .catch((err) => {
        throw new Error(err?.response?.data?.message ?? err);
      })
      .then(HttpAgent.responseBody);
  }

  static put(url, body, header) {
    return axios
      .put(url, body, header)
      .catch((err) => {
        throw new Error(err?.response?.data?.message ?? err);
      })
      .then(HttpAgent.responseBody);
  }

  static delete(url, header) {
    return axios
      .delete(url, header)
      .catch((err) => {
        throw new Error(err?.response?.data?.message ?? err);
      })
      .then(HttpAgent.responseBody);
  }
}
